<div [formGroup]="form">
  <div class="flexRow mt-1">
    <p>{{ "forms.prescription.chargeDoctor" | translate }}</p>
    <mat-form-field>
      <mat-label>{{ "forms.prescription.chargeDoctor" | translate }}</mat-label>
      <mat-select formControlName="practitioner">
        <mat-option [value]="null" class="unselect">- {{ "forms.null" | translate }} -</mat-option>
        <mat-option *ngFor="let doc of data.availableDoctors" [value]="doc"
          >{{ doc | getPractitionerName : practitionerService }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <mat-checkbox class="mt-1 mb-1" formControlName="availableToService" labelPosition="before">{{
    "forms.prescription.importTemplate.serviceAccessibility" | translate
  }}</mat-checkbox>
</div>
<button class="mt-1" type="button" style="float: right" mat-raised-button (click)="save()">
  {{ "forms.prescription.importTemplateBtn" | translate }}
</button>
